<template>
  <div class="header-wrapper">
    <div class="menu-wrapper"></div>
    <div class="container-form">
      <div class="content-form">
        <img
          src="@/assets/images/logo-page.png"
          alt="logo top"
          class="logo-top"
        />
        <el-form
          :model="loginForm"
          :rules="validator"
          ref="loginForm"
          label-width="150px"
          class="login-form login"
          label-position="top"
          @keyup.enter.native="submitForm('loginForm')"
        >
          <el-form-item :label="$t('login.email')" prop="email">
            <el-input
              type="email"
              v-model="loginForm.email"
              autocomplete="off"
              class="email"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('login.password')" prop="password">
            <el-input
              :type="showPassword ? 'text' : 'password'"
              v-model="loginForm.password"
              autocomplete="off"
              class="password"
            >
              <img
                :src="showPassword ? showIcon : hiddenIcon"
                slot="suffix"
                alt=""
                class="mtb-15 mlr-10 icon-pass"
                @click="showPassword = !showPassword"
              />
            </el-input>
          </el-form-item>

          <el-form-item class="btn-wrap">
            <el-button
              class="button-login"
              :disabled="checkLogin"
              @click="submitForm('loginForm')"
            >
              {{ $t('login.btnLogin') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import hiddenIcon from '@/assets/images/hide-pass.svg';
import showIcon from '@/assets/images/show-pass.svg';
import { authService } from '@/services/auth.service';
import * as pageRouter from '@/constants/pageRouter';
import { handleError } from '@/helper';

export default {
  data() {
    return {
      hiddenIcon,
      showIcon,
      checkLogin: false,

      showPassword: false,
      loginForm: {
        email: '',
        password: '',
      },
      validator: {
        email: [
          {
            required: true,
            message: this.$t('validate.require'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.require'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(loginForm) {
      this.$refs[loginForm].validate(async (valid) => {
        if (valid) {
          this.checkLogin = true;
          try {
            const response = await authService.login({
              userName: this.loginForm.email,
              password: this.loginForm.password,
            });
            if (response.success && this.$route.path !== pageRouter.EMPLOYEE) {
              this.$router.push(pageRouter.EMPLOYEE);
            }
          } catch (error) {
            handleError(error);
          } finally {
            this.checkLogin = false;
          }
        }
      });
    },
  },
  watch: {
    'loginForm.email'() {
      this.$refs['loginForm'].clearValidate('email');
    },
    'loginForm.password'() {
      this.$refs['loginForm'].clearValidate('password');
    },
  },
};
</script>

<style lang="scss">
@import './styles.module.scss';
</style>
